/* eslint-disable no-param-reassign  */
import { createSlice } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import BidRequestRepository from 'repositories/buyer/BidRequestRepository';

const initialState = {
  loading: false,
  saving: false,
  creating: false,
  progress: 0,
  bidRequest: {},
};

const bidRequestSlice = createSlice({
  name: 'bidRequestSlice',
  initialState,
  reducers: {
    saveBidRequestStart(state) {
      state.saving = true;
    },
    saveBidRequestSuccess(state) {
      state.saving = false;
    },
    saveBidRequestFail(state) {
      state.saving = false;
    },
    saveAndOpenBidRequestStart(state) {
      state.creating = true;
      state.progress = 20;
    },
    progressChange(state, { payload }) {
      state.progress = payload;
    },
    saveAndOpenBidRequestSuccess(state) {
      state.creating = false;
      state.progress = 0;
    },
    saveAndOpenBidRequestFail(state) {
      state.creating = false;
    },
    loadBidRequestStart(state) {
      state.loading = true;
    },
    loadBidRequestSuccess(state, { payload }) {
      state.loading = false;
      const { attributes, id } = payload;
      state.bidRequest = { ...attributes, id };
    },
    loadBidRequestFail(state) {
      state.loading = false;
    },
    openBidRequestStart(state) {
      state.saving = true;
    },
    openBidRequestSuccess(state) {
      state.saving = false;
    },
    openBidRequestFail(state) {
      state.saving = false;
    },
  },
});

export const { actions } = bidRequestSlice;

export default bidRequestSlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const saveAndOpenBidRequest = async attrs => {
    dispatch(actions.saveAndOpenBidRequestStart());
    try {
      const response = await BidRequestRepository.saveAndOpen(attrs);
      setTimeout(() => {
        dispatch(actions.progressChange(40));
      }, 100);

      setTimeout(() => {
        dispatch(actions.progressChange(80));
      }, 400);

      setTimeout(() => {
        dispatch(actions.progressChange(100));
      }, 800);

      await new Promise(resolve => {
        setTimeout(() => {
          dispatch(actions.saveAndOpenBidRequestSuccess(response));
          resolve();
        }, 1200);
      });
      return response;
    } catch (error) {
      dispatch(actions.saveAndOpenBidRequestFail());
      return Promise.reject(error);
    }
  };

  const saveBidRequest = async attrs => {
    dispatch(actions.saveBidRequestStart());
    try {
      const response = await BidRequestRepository.save(attrs);
      dispatch(actions.saveBidRequestSuccess(response));
      return response;
    } catch (error) {
      dispatch(actions.saveBidRequestFail());
      return Promise.reject(error);
    }
  };

  const openBidRequest = async attrs => {
    dispatch(actions.openBidRequestStart());
    try {
      await BidRequestRepository.open(attrs);
      dispatch(actions.openBidRequestSuccess());
    } catch (_error) {
      dispatch(actions.openBidRequestFail());
    }
  };

  const loadBidRequest = async () => {
    dispatch(actions.loadBidRequestStart());
    try {
      const { data } = await BidRequestRepository.show();
      dispatch(actions.loadBidRequestSuccess(data));
      return data;
    } catch (error) {
      dispatch(actions.loadBidRequestFail());
      return Promise.reject(error);
    }
  };

  return {
    saveBidRequest,
    openBidRequest,
    saveAndOpenBidRequest,
    loadBidRequest,
  };
};
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./src/reducers/slices/bidRequestSlice.js